module.exports = __webpack_public_path__ + "img/cdf48c9.png";